module.exports = __webpack_public_path__ + "img/1286546938.c4c824e8.jpg";